import { Button, Col, DatePicker, Form, FormInstance, Input, InputNumber, message, Row, Space, Tooltip } from 'antd';
import moment from 'moment';
import React, { Component, createRef } from 'react'
import { connect } from 'react-redux';
import { stepperMoving, getDataInfo } from '../../stores/actions';
import { getApi, postApi, request } from '../../../../shared/src/apis';
import { assignVipUser, unAssignVipUser } from '../../utils/apisConsts';
import { UserInfoUI } from '@operations/shared';
import helper from '../../utils/helper';
import { InfoCircleOutlined } from '@ant-design/icons';

// import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

// const { Option } = Select;
interface userInfo {
    name: string,
    staff_id: number,
    companyName: string,
    userID: number,
    phone: string,
    jobTitle: string,
    email: string,
    vipFreeMonths: number | null,
    vipFreeMonthsStartDate: string | null,
    vipFreeMonthsEndDate: string,
    vipMinFreeInstallments: number,
    companyMaxInstallmentCount: number,
    hiringDate: string,
    vipMaxAmount: number,
}
interface Props {
    info: userInfo,
    getApi: any,
    postApi: any,
    stepperMoving: any,
    request: any,
    fromViewUserAction: boolean,
    getDataInfo: any,
}

export class AssignUser extends Component<Props> {
    formRef = createRef<FormInstance>();
    state = {
        loading: false
    }
    assignUser = async (value: { vibFreeMonths: string, startDate: string, endDate: string, minNumberOfInstallments: string, vipMaxAmount: number }) => {
        if (Number(value?.minNumberOfInstallments) > this.props.info?.companyMaxInstallmentCount) {
            message.error(`The minimum number of months has to be less than ${this.props.info?.companyMaxInstallmentCount} which is the maximum number of installments in the company configuration. i.e the user’s request will be totally free.`);
        } else {

            this.setState({ loading: true })
            const data = {
                userID: this.props.info?.userID,
                vipFreeMonths: value.vibFreeMonths,
                vipFreeMonthsStartDate: value.startDate,
                vipFreeMonthsEndDate: value.endDate,
                vipMinFreeInstallments: value.minNumberOfInstallments,
                vipMaxAmount: value.vipMaxAmount ? value.vipMaxAmount : value.vipMaxAmount === 0 ? 0 : null
            }
            if (this.props.info?.companyMaxInstallmentCount === Number(value?.minNumberOfInstallments)) message.warning(`The minimum number of months is equal to ${this.props.info?.companyMaxInstallmentCount} which is the maximum number of installments in the company configuration. i.e the user’s request will be totally free.`)
            try {
                const request = await this.props.request({ url: assignVipUser, method: "put", data: data });
                const res = await request?.data;
                if (res?.status === 200) {
                    this.setState({ loading: false })
                    message.success(res?.message, 4);
                    this.formRef.current!.resetFields();
                    if (this.props.fromViewUserAction) {
                        this.formRef.current?.setFieldsValue(value)
                        this.props.getDataInfo({ ...this.props?.info, ...data });
                        this.props.stepperMoving(1);
                    } else {
                        helper.resetAccountTableInStepper();
                        this.props.stepperMoving(0);
                    }
                } else {
                    this.setState({ loading: false })
                    message.error(res?.message, 4);
                }
            } catch (error) {
                console.log("🚀 ~ file: assignUser.tsx ~ line 25 ~ AssignUser ~ assignUser= ~ error", error);
                this.setState({ loading: false });
                message.error('Something went wrong, please try again', 4);
            }
        }
    }

    unAssignUser = async () => {
        this.setState({ loading: true })
        const request = await this.props.request({ url: unAssignVipUser, method: "PATCH", data: { userID: this.props.info?.userID } });
        try {
            const res = await request.data;
            if (res?.status === 200) {
                this.setState({ loading: false })
                message.success(res?.message, 4);
                if (this.props?.fromViewUserAction) {
                    this.formRef.current?.setFieldsValue({
                        vibFreeMonths: '',
                        startDate: null,
                        endDate: null,
                        minNumberOfInstallments: '',
                        vipMaxAmount: 100000
                    })
                    this.props.getDataInfo({
                        ...this.props?.info,
                        vipFreeMonths: null,
                        vipFreeMonthsStartDate: null,
                        vipFreeMonthsEndDate: null,
                        vipMinFreeInstallments: null,
                        vipMaxAmount: null
                    });
                    this.props.stepperMoving(1);
                } else {
                    helper.resetAccountTableInStepper();
                    this.props.stepperMoving(0);
                }
            } else {
                this.setState({ loading: false })
                message.error(res?.message, 4);
            }
        } catch (error) {
            this.setState({ loading: false });
            message.error('Something went wrong, please try again', 4);
        }
    }

    dropDownSearch = (input: string, option: { children: string; }) => {
        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
    render() {
        const { loading } = this.state;
        console.log(this.props.info.vipFreeMonthsStartDate);

        const vipUserInfo = [
            {
                key: 'Number of Free Months',
                value: <Form.Item
                    name={'vibFreeMonths'}
                    initialValue={this.props.info.vipFreeMonths ?? ''}
                    rules={[{ required: true, message: 'Required' }, { type: 'number', min: 1, max: 60, message: 'must be between 1 and 60' }]}
                >
                    <InputNumber style={{ width: '100%' }} placeholder='Enter The number of months' onChange={
                        () => {
                            this.formRef?.current?.getFieldValue('minNumberOfInstallments') && this.formRef?.current?.validateFields(['minNumberOfInstallments']);
                        }
                    } />
                </Form.Item>
            },
            {
                key: 'Start Date',
                value: <Form.Item
                    name={'startDate'}
                    rules={[{ required: true, message: 'Required' }]}
                    initialValue={this.props.info?.vipFreeMonthsStartDate ? moment(this.props.info?.vipFreeMonthsStartDate) : null}
                >
                    <DatePicker style={{ width: '100%' }} disabledDate={(current) => {
                        let customDate = moment().format("YYYY-MM-DD");
                        return current && current < moment(customDate, "YYYY-MM-DD");
                    }}
                        onChange={
                            () => {
                                this.formRef?.current?.getFieldValue('endDate') && this.formRef?.current?.validateFields(['endDate']);
                            }}
                    />
                </Form.Item>
            },
            {
                key: 'End Date',
                value: <Form.Item
                    name={'endDate'}
                    rules={[{ required: true, message: 'Required' },
                    {
                        validator: (_, value) => {
                            const startDate = this.formRef?.current?.getFieldValue('startDate');
                            if (value === undefined || value === '' || !value) {
                                return Promise.resolve();
                            }
                            else if (startDate && value && moment(value).isSameOrBefore(moment(startDate), 'day')) {
                                return Promise.reject(new Error('End Date must be after Start Date'));

                            }
                            return Promise.resolve();
                        }
                    }]}
                    initialValue={this.props.info?.vipFreeMonthsEndDate ? moment(this.props.info?.vipFreeMonthsEndDate) : null}
                >
                    <DatePicker style={{ width: '100%' }} disabledDate={(current) => {
                        const startDate = this.formRef?.current?.getFieldValue('startDate');
                        const today = moment().startOf('day');
                        if (!current) return false;
                        if (current?.isSameOrBefore(today, 'day')) {
                            return true;
                        }

                        if (startDate) {
                            const selectedStart = moment(startDate).startOf('day');
                            if (selectedStart?.isAfter(today)) {
                                return current?.isSameOrBefore(selectedStart, 'day');
                            }
                        }
                        return false;
                    }} />
                </Form.Item>
            },
            {
                key: 'Minimum Number Of Installments',
                value: <Form.Item
                    name={'minNumberOfInstallments'}
                    initialValue={this.props.info?.vipMinFreeInstallments ?? ''}
                    rules={[{ required: true, message: 'Required' },
                        { type: 'number', min: 1, max: 60, message: 'must be between 1 and 60' },
                    {
                        validator: (_, value) => {
                            const vipFreeMonths = this.formRef?.current?.getFieldValue('vibFreeMonths');
                            if (value === undefined || value === '' || !value) {
                                return Promise.resolve();
                            }
                            else if (value !== undefined && vipFreeMonths !== undefined && value < vipFreeMonths) {
                                return Promise.reject(new Error('Minimum Installments must be greater than equal or Number of Free Months'));
                            }
                            return Promise.resolve();
                        }
                    }
                    ]}
                >
                    <InputNumber style={{ width: '100%' }} placeholder='Enter The minimum number Of installments' />
                </Form.Item>
            },
            {
                key: <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <label> Max Allowed Amount </label>
                    <Tooltip title="Leave this field empty or enter 0 if you don’t want this offer to have a limit on the total request amount.">
                        <InfoCircleOutlined style={{ marginBottom: '7px', color: 'red' }} />
                    </Tooltip>
                    &nbsp;
                </div>,
                value: <> <Form.Item
                    name={"vipMaxAmount"}
                    initialValue={this.props.info?.vipMaxAmount === null && this.props.info?.vipFreeMonthsStartDate ? null : this.props.info?.vipMaxAmount ? this.props.info?.vipMaxAmount : 100000}
                    rules={[
                        { type: "number", min: 0, message: "Must be a positive number" }
                    ]}
                    normalize={value => (value === "" ? undefined : Number(value))}
                >
                    <Input type="number" min={0} placeholder={`No Max Amount selected`} />
                </Form.Item>
                </>
            }

        ]
        return (
            <div className='userFeesModel'>
                <div className="assignUser">

                    <Form
                        ref={this.formRef}
                        initialValues={{ type: "type_1" }}
                        onFinish={this.assignUser}
                    >

                        <Row>

                            <Col span={24}>
                                <UserInfoUI userData={vipUserInfo} activeKey={1} header={'VIP User'} nonEditable={true} collapsible={"disabled"} />
                            </Col>
                            <Space style={{ display: 'flex', width: '100%', justifyContent: 'end', margin: '30px 0 0 0 ' }}>
                                <Form.Item>
                                    <Button style={{ backgroundColor: "#7CC58F", borderColor: "#7CC58F" }} type="primary" htmlType="submit" loading={loading}>
                                        Submit
                                    </Button>
                                </Form.Item>
                                <Form.Item>
                                    <Button danger htmlType='reset' loading={loading}

                                        disabled={!this.props.info?.vipFreeMonthsStartDate}
                                        onClick={this.unAssignUser}
                                    >
                                        Unassign
                                    </Button>
                                </Form.Item>
                            </Space>
                        </Row>

                    </Form>

                </div>

            </div>
        )
    }
}
const mapStateToProps = (state: any) => ({
    info: state.actionsReducer.info,
    fromViewUserAction: state.actionsReducer.isViewUserAction,
})
export default connect(mapStateToProps, { getApi, postApi, stepperMoving, request, getDataInfo })(AssignUser)
